var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGearSix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 20.7079C18.1066 20.7079 20.625 18.2145 20.625 15.1386C20.625 12.0628 18.1066 9.56934 15 9.56934C11.8934 9.56934 9.375 12.0628 9.375 15.1386C9.375 18.2145 11.8934 20.7079 15 20.7079Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1328 9.65047C23.4149 10.0504 23.6619 10.4735 23.8711 10.9152L26.9063 12.586C27.2852 14.2666 27.2892 16.0088 26.918 17.6912L23.8711 19.3619C23.6619 19.8036 23.4149 20.2267 23.1328 20.6266L23.1914 24.0727C21.9051 25.2332 20.3827 26.1075 18.7266 26.6369L15.7383 24.8616C15.2467 24.8965 14.7533 24.8965 14.2617 24.8616L11.2852 26.6253C9.6238 26.1056 8.09636 25.2346 6.8086 24.0727L6.86719 20.6382C6.58743 20.2328 6.34056 19.806 6.12891 19.3619L3.09375 17.6912C2.71477 16.0105 2.71077 14.2683 3.08203 12.586L6.12891 10.9152C6.33807 10.4735 6.58507 10.0504 6.86719 9.65047L6.8086 6.20446C8.09491 5.04392 9.61733 4.16958 11.2734 3.64026L14.2617 5.41548C14.7533 5.38066 15.2467 5.38066 15.7383 5.41548L18.7148 3.65186C20.3762 4.17154 21.9036 5.04251 23.1914 6.20446L23.1328 9.65047Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearSix);
export default __webpack_public_path__ + "static/media/GearSix.c3b2268e8ba20a404ce0c45bcd2f4b6e.svg";
export { ForwardRef as ReactComponent };